<template>
  <div>
    <el-dialog :visible="showLogin1" id="loginMask" @close="closeLogin" center>
      <span slot="title">
        <img class="readFail-img" src="../../../assets/logo1-m@1x.png" alt>
      </span>
      <el-row>
        <el-form
          :model="loginForm"
          :rules="rules"
          ref="loginForm"
          label-width="100px"
          class="demo-ruleForm"
          :label-position="labelPosition"
        >
          <el-form-item label="User name" prop="email" class="emailLogin" :error="errorEmailMsg">
            <el-input
              v-model="loginForm.email"
              placeholder="Enter your Email Address"
              @keyup.enter.native="submitForm('loginForm')"
            ></el-input>
          </el-form-item>
          <el-form-item label="Password" prop="password" class="passLogin" :error="errorPassMsg">
            <el-input
              v-model="loginForm.password"
              placeholder="Password"
              type="password"
              @keyup.enter.native="submitForm('loginForm')"
            ></el-input>
            <a @click="showForgotPass" class="forgotPass">Forgot Password</a>
          </el-form-item>
          <el-form-item class="checkForm">
            <el-checkbox v-model="checked">Keep me logged in</el-checkbox>
          </el-form-item>
          <el-form-item class="loginButton" :class="{'disbled':disbledSubmit}">
            <el-button type="primary" class="login-button" @click="submitForm('loginForm')">Login</el-button>
          </el-form-item>
          <el-form-item class="loginLink">
            <p class="link-text pull-left">Don’t have an account?</p>
            <a @click="showAccount" class="newAccount pull-left">Sign up now</a>
          </el-form-item>
        </el-form>
      </el-row>
    </el-dialog>
    <!-- reset password -->
    <forgotPass ref="forgotPassForm"></forgotPass>
  </div>
</template>

<script>
export default {
  name: 'GjLogin',
  componentName: 'GjLogin',
  data() {
    return {
      // 错误信息
      errorEmailMsg: '',
      errorPassMsg: '',
      // showLogin: false,
      // showLogin1: false,
      labelPosition: 'top',
      checked: true,
      disbledSubmit: false,
      loginForm: {
        email: this.$store.state.register.name,
        password: ''
      },
      rules: {
        email: [{
          required: true,
          message: 'Enter your Email Address',
          trigger: 'change'
        }, {
          validator: (rule, value, callback) => {
            if (!(/^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/.test(value)) || !(/^((\(\d{2,3}\))|(\d{3}\-))?1[3,4,5,6,7,8,9]{1}\d{9}$/)) {
              callback(new Error('Invalid Email Address Format'))
            } else {
              callback();
            }
          },
          trigger: 'blur'
        }],
        password: [{
          required: true,
          message: 'Enter your password',
          trigger: 'change'
        }, {
          min: 6,
          max: 30,
          message: 'Use 6-30 characters with a mix of letters&numbers',
          trigger: 'blur'
        }, {
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('Enter your password'))
            } else if (/^[\u4e00-\u9fa5]|[\s+]+$/.test(value)) {
              callback(new Error('Invalid password Format'))
            } else {
              callback();
            }
          },
          trigger: 'blur'
        }]
      }
    }
  },
  computed: {
    forgotPassVisible() {
      return this.$store.state.forgotPassVisible
    },
    showLogin1() {
      return this.$store.state.showLogin
    }
  },
  watch: {
    forgotPassVisible: function (value) {
      const oforgotPass = this.$refs.forgotPassForm
      oforgotPass.forgotPassVisible = value
    }
  },
  created() {
    // this.loginForm.email = localStorage.getItem('loginEmail')
  },
  methods: {
    // handleClick(url) {
    //   if (url) {
    //     this.$router.push(url)
    //   }
    //   this.closeLogin()
    // },
    // 显示注册dialog
    showAccount() {
      this.$store.commit('accountVisible', true)
      this.closeLogin()
    },
    // 显示忘记密码dialog
    showForgotPass() {
      this.$store.commit('forgotPassVisible', true)
      this.closeLogin()
    },
    closeLogin() {
      this.$store.commit('showLogin', false)
      this.$refs.loginForm.resetFields();
    },
    submitForm(loginForm) {
      this.$refs[loginForm].validate((valid) => {
        if (valid) {
          this.checkEmail().then((res) => {
            if (res) {
              this.loginSubmit()
            }
          })
        } else {
          return false;
        }
      });
    },
    loginSubmit() {
      this.errorPassMsg = '';
      this.$http.post(this.API.loginSubmit, this.loginForm).then((res) => {
        const data = res.data
        if (data.code === '000000') {
          const token = data.data.gjCookieLoginKey
          localStorage.setItem('gjCookieLoginKey', token)
          this.$store.commit('login', {
            name: this.loginForm.email,
            token: token
          })
          this.closeLogin()
        } else {
          this.errorPassMsg = data.message
          return false
        }
      })
    },
    checkEmail() { // 校验账号是否注册过
      this.errorEmailMsg = '';
      return new Promise((resolve, reject) => {
        this.$http.get(this.API.getCheckRegistEmail, {
          params: {
            email: this.loginForm.email
          }
        }).then((res) => {
          const data = res.data
          if (data.code === '000000' && data.data) {
            resolve(true)
          } else {
            this.errorEmailMsg = data.message
            resolve(false)
          }
        })
      })
    },
    userDropdown() {
      this.showUserInfo = !this.showUserInfo
    }
  }
}
</script>

<style lang="scss">
#loginMask {
  .el-dialog {
    width: 28.125rem;
    border-radius: 0.625rem;
  }
  .el-dialog__header {
    height: 10.125rem;
  }
  // .el-dialog__header {
  //   height: 10.125rem;
  //   background: url('../../../assets/loginbk-m@1x.png') center center no-repeat;
  //   background-size: 100% 90%;

  //   .readFail-img {
  //     margin-top: 2rem;
  //   }
  // }

  .el-dialog__headerbtn {
    z-index: 10;
  }

  .el-dialog__body {
    padding: 0;
  }

  .login-main {
    margin: 8.125rem auto 0;
    box-shadow: 0px 0.25rem 0.75rem 0px rgba(0, 0, 0, 0.2);
  }

  .el-form {
    padding: 2.25rem 3.625rem;
    padding-top: 0;
    margin-top: -1rem;

    .loginTitle {
      height: 2.5rem;
      font-size: 1.875rem;
      font-weight: 700;
      line-height: 2.5rem;
      color: #2f457c;
    }

    .loginLine {
      width: 3.125rem;
      height: 0.125rem;
      background-color: #2f457c;
      margin-top: 0.8125rem;
    }

    .el-form-item__label {
      font-size: 1.125rem;
      color: #2f457c;
      height: 1.5rem;
      line-height: 1.5rem;
    }

    .el-form-item__label::before {
      display: none;
    }

    .el-checkbox__label {
      color: #6A798E;
      font-size: 0.875rem;
      height: 1rem;
      line-height: 1rem;
      padding-left: 0.375rem;
    }

    .passLogin {
      margin-bottom: 0;

      .el-form-item__content {
        .forgotPass {
          position: absolute;
          top: -2.5rem;
          right: 0;
          cursor: pointer;
          text-decoration: underline;
        }
      }
    }

    .el-form-item {
      text-align: left;

      .el-input__inner {
        background-color: #f1f4f8;
        border: none;
      }
    }
    .emailLogin {
      margin-bottom: 2rem;
    }

    .checkForm {
      margin-bottom: 1.5rem;
      line-height: 1;
    }

    .loginButton {
      margin-bottom: 1.25rem;

      button {
        width: 100%;
        outline: none;
      }
    }

    .loginLink {
      margin-bottom: 0;

      .link-text {
        margin-left: 2rem;
        font-size: 1rem;
        color: #6a798e;
      }

      .newAccount {
        cursor: pointer;
        text-decoration: underline;
        font-size: 1rem;
        color: #6a798e;
        font-weight: 600;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/login/src/main.vue